export default "__VITE_ASSET__BgdNoNZi__"